<template>
  <div>
    <generic-container
      :title="$t('teacher rating')"
      icon="star"
      :show_plus="false"
      :configurable="false"
      :show_back="true"
      v-bind:configure_modal="configure_modal"
      :header_buttons="header_buttons"
    >
      <div class="ui form" ref="form">
        <!-- <h4 class="ui dividing header">{{ $t("basic information") }}</h4> -->
        <div class="fields">
          <div class="four wide field">
            <label>{{ $t("teacher to evaluate") }}</label>
            <div class="ui search selection dropdown" ref="users_dropdown">
              <input type="hidden" name="user" />
              <i class="dropdown icon"></i>
              <div class="default text">{{ $t("user") }}</div>
              <div class="scrollhint menu"></div>
            </div>
          </div>
          <div class="twelve wide field">
            <div class="ui icon message">
              <i class="info icon"></i>
              <div class="content">
                <div class="header">
                  {{ $t("hints") }}
                </div>
                <div class="ui bulleted list">
                  <div class="item">
                    {{
                      $t(
                        "make sure to select a teacher o evaluate on the list at the left side",
                      )
                    }}
                  </div>
                  <div class="item">
                    {{
                      $t(
                        "if you don't have teachers available on the list, make sure this module is configured with the right tree and the tree node is setted with your user",
                      )
                    }}
                  </div>
                  <div class="item">
                    {{ $t("click on the day you want to rate") }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <FullCalendar
        v-show="target_user_id"
        ref="fullCalendar"
        defaultView="dayGridMonth"
        :plugins="calendarPlugins"
        :header="header"
        :events="events"
        v-bind:locale="$i18n.locale"
        editable="true"
        @dateClick="dateClick"
        @eventClick="eventClick"
      />
      <!-- <table
        class="ui blue very compact celled striped selectable table"
        ref="table"
        style="width: 100%"
      >
        <thead>
          <tr>
            <th>{{ $t("teacher") }}</th>
            <th>{{ $t("rating") }}</th>
            <th>{{ $t("rating date") }}</th>
            <th>{{ $t("create date") }}</th>
          </tr>
        </thead>
        <tbody></tbody>
      </table> -->
    </generic-container>
    <rating-modal ref="rating_modal" @saved="saved" @deleted="saved" />
  </div>
</template>

<script>
import filters from "@/filters";
import GenericContainer from "@/components/GenericContainer";
import ConfigureModal from "./configuration_modal/Index.vue";
import { v4 } from "uuid";
import { /* init_ajax_data_datables, */ enterprise_setup } from "@/utils";
import RatingModal from "./rating_modal/Index";
// import moment from "moment";

import "@fullcalendar/core/main.css";
import "@fullcalendar/daygrid/main.css";
import "@fullcalendar/timegrid/main.css";
import FullCalendar from "@fullcalendar/vue";
import dayGridPlugin from "@fullcalendar/daygrid";
// import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import "@fullcalendar/core/locales-all";

import { local_api, error_toast, warning_toast } from "@/utils";

// @ is an alias to /src
export default {
  name: "TeacherRatingIndex",
  components: {
    "generic-container": GenericContainer,
    FullCalendar,
    RatingModal,
  },
  filters: filters,
  computed: {
    enterprise_setup() {
      return enterprise_setup(this);
    },
  },
  data() {
    return {
      configure_modal: ConfigureModal,
      header_buttons: [
        // {
        //   icon: "refresh",
        //   tooltip: this.$t("refresh"),
        //   click: this.refresh,
        // },
      ],
      calendarPlugins: [dayGridPlugin, /* timeGridPlugin, */ interactionPlugin],
      header: {
        left: "prev,next today",
        center: "title",
        right: "dayGridMonth,timeGridDay",
        // right: "dayGridMonth,timeGridWeek,timeGridDay",
      },
      target_user_id: "",
      target_user_name: "",
      target_organization_id: "",
      target_template_id: "",
      ratings: [],
    };
  },
  methods: {
    saved() {
      let vm = this;
      let api = vm.$refs.fullCalendar.getApi();
      api.refetchEvents();
    },
    dateClick(info) {
      let vm = this;
      if (!vm.target_user_id) warning_toast(vm.$t("first select user to rate"));
      else {
        let trgtEvnt = vm.ratings.find((rt) => {
          return rt.evaluation_date == info.dateStr;
        });
        // let startRating = "";
        let comment = "";
        let uuid = null;
        let response = [];
        if (trgtEvnt) {
          // console.log("trgtEvnt", trgtEvnt);
          // startRating = trgtEvnt.scoring;
          uuid = trgtEvnt.uuid;
          comment = trgtEvnt.setup.comment || "";
          response = trgtEvnt.staff_rating_evaluation.response || [];
        }

        vm.$refs.rating_modal.show_modal({
          // startRating: startRating,
          response: response,
          uuid: uuid,
          info: info,
          target_user_id: vm.target_user_id,
          target_user_name: vm.target_user_name,
          comment: comment,
          target_organization_id: vm.target_organization_id,
          target_template_id: vm.target_template_id,
        });
      }
    },
    eventClick(info) {
      let vm = this;
      let event = info.event.extendedProps.modul_object;
      vm.$refs.rating_modal.show_modal({
        // startRating: event.scoring,
        uuid: event.uuid,
        info: { dateStr: event.evaluation_date },
        target_user_id: vm.target_user_id,
        target_user_name: vm.target_user_name,
        comment: event.setup.comment || "",
        response: event.staff_rating_evaluation.response || [],
        target_organization_id: vm.target_organization_id,
        target_template_id: vm.target_template_id,
      });
    },
    events(fetchInfo, successCallback, failureCallback) {
      let vm = this;
      if (vm.target_user_id) {
        fetchInfo.rated_user = vm.target_user_id;
        fetchInfo.organization_id = vm.target_organization_id;
        local_api(
          vm,
          "post",
          "/staff_rating/teacher/do-get-own-rating",
          fetchInfo,
        )
          .then((response) => {
            // console.log("response", response);
            vm.ratings = response;
            let events = response.map((evt) => {
              return {
                id: evt.uuid,
                title: evt.setup.comment || vm.$t("no comment yet"),
                start: evt.evaluation_date,
                end: evt.evaluation,
                modul_object: evt,
                // description: evt.setup.description,
                // editable: true,
                // startEditable: true,
                // durationEditable: true,
                // overlap: true,
                // color: evt.setup.color,
              };
            });
            successCallback(events);
          })
          .catch((err) => {
            console.error(err);
            failureCallback(err);
          })
          .finally(() => {});
      }
    },
  },
  created() {},
  mounted() {
    let vm = this;
    local_api(vm, "post", "/staff_rating/teacher/do-get-users")
      .then((users) => {
        // vm.users = user;

        let vls = users.map((i) => {
          return {
            value: v4(),
            name: i.username,
            description: `${i.tree.name}/${i.template.name}`,
            stx: i,
          };
        });
        window
          .jQuery(vm.$refs.users_dropdown)
          .dropdown("setup menu", { values: vls })
          .dropdown({
            onChange(value) {
              let trgtvl = vls.find((u) => {
                return u.value == value;
              });
              let usr = trgtvl.stx;
              // console.log(usr);
              vm.target_user_id = usr.user_id;
              vm.target_organization_id = usr ? usr.tree.organization_id : "";
              vm.target_template_id = usr ? usr.template.template_id : "";
              vm.target_user_name = usr ? usr.name : "";

              let api = vm.$refs.fullCalendar.getApi();
              api.refetchEvents();
              // console.log(api);
            },
          });
      })
      .catch((err) => {
        error_toast(err);
      });
  },
  watch: {},
};
</script>
